import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';

/**
 *
 */
@Injectable({
  providedIn: 'root',
})
export class EmailService {

  private lambda: AWS.Lambda;
  // * The constructor
  constructor() {
    // Initialize the Amazon Cognito credentials provider
    AWS.config.region = 'eu-west-1'; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'eu-west-1:8b3e0916-1d83-4efa-9cde-053303a34e4e',
    });
    this.lambda = new AWS.Lambda({  
      region: AWS.config.region,
      apiVersion: '2015-03-31',
    });
  }

  /**
   * Send an email from contact@reliefapplications.org to contact@reliefapplications.org with specified subject, content and cc.
   *
   * @param params the object mail
   * @param params.subject Subject of the email.
   * @param params.content Body of the email.
   * @param params.to Cc of the email.
   * @param callback Callback to be runned after the email is sent.
   */
  sendEmail(
    params: {
      subject: any;
      content: any;
      to: any | any[];
    },
    callback: (err:any, data:any) => any
  ): void {
    const pullParams = {
      FunctionName: 'reliefapps_email_broker',
      InvocationType: 'RequestResponse',
      LogType: 'None',
      Payload: JSON.stringify(params),
    };

    this.lambda.invoke(pullParams, callback);
  }
}
